export default {
      id: "transactions-transparent-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#transactions-transparent",
      toString: function () {
        return this.url;
      }
    }